module.exports = __webpack_public_path__ + "static/media/platform@2x.0054748b.png";